<template>
  <div class="auditoria-layout">
    <div class="auditoria-sidebar" :class="{ collapsed: sidebarCollapsed }">
      <div class="sidebar-header">
        <div class="logo">
          <img src="@/assets/images/logo.png" alt="Logo" v-if="!sidebarCollapsed" />
          <i class="fas fa-shield-alt" v-else></i>
        </div>
        <button @click="toggleSidebar" class="sidebar-toggle">
          <i :class="sidebarCollapsed ? 'fas fa-chevron-right' : 'fas fa-chevron-left'"></i>
        </button>
      </div>

      <nav class="sidebar-nav">
        <ul class="nav-menu">
          <li class="nav-item">
            <router-link to="/auditoria/dashboard" class="nav-link" active-class="active">
              <i class="fas fa-home"></i>
              <span v-if="!sidebarCollapsed">Início</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/auditoria/dashboard/concursos" class="nav-link" active-class="active">
              <i class="fas fa-clipboard-list"></i>
              <span v-if="!sidebarCollapsed">Concursos</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/auditoria/dashboard/inscricoes" class="nav-link" active-class="active">
              <i class="fas fa-file-alt"></i>
              <span v-if="!sidebarCollapsed">Inscrições</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/auditoria/dashboard/documentos-inscricao" class="nav-link" active-class="active">
              <i class="fas fa-folder-open"></i>
              <span v-if="!sidebarCollapsed">Cartões Respostas</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>

    <div class="auditoria-main" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
      <header class="auditoria-header">
        <div class="header-left">
          <h1 class="page-title">{{ currentPageTitle }}</h1>
        </div>
        <div class="header-right">
          <div class="user-info">
            <div class="user-avatar">
              <i class="fas fa-user-check"></i>
            </div>
            <div class="user-details">
              <span class="user-name">{{ auditorUser.nome || 'Auditor' }}</span>
              <span class="user-role">Auditoria</span>
            </div>
          </div>
          <button @click="logout" class="btn-logout">
            <i class="fas fa-sign-out-alt"></i>
            <span>Sair</span>
          </button>
        </div>
      </header>

      <main class="auditoria-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AuditoriaLayout',
  data() {
    return {
      sidebarCollapsed: false,
      auditorUser: {}
    }
  },
  computed: {
    currentPageTitle() {
      return this.$route.meta.title || 'Auditoria'
    }
  },
  mounted() {
    this.loadAuditorUser()
    this.checkAuth()
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    },
    loadAuditorUser() {
      try {
        const token = localStorage.getItem('auditor-token')
        if (token) {
          const payload = JSON.parse(atob(token.split('.')[1]))
          if (payload.data && payload.data[0] && payload.data[0].usuario) {
            this.auditorUser = payload.data[0].usuario
          }
        } else {
          const stored = localStorage.getItem('auditor-user')
          if (stored) this.auditorUser = JSON.parse(stored)
        }
      } catch (e) {
        localStorage.removeItem('auditor-token')
        localStorage.removeItem('auditor-user')
        if (this.$route.path !== '/auditoria/login') this.$router.push('/auditoria/login')
      }
    },
    checkAuth() {
      const token = localStorage.getItem('auditor-token')
      if (!token) {
        if (this.$route.path !== '/auditoria/login') this.$router.push('/auditoria/login')
        return
      }
      try {
        const payload = JSON.parse(atob(token.split('.')[1]))
        const now = Math.floor(Date.now() / 1000)
        if (payload.exp < now) {
          localStorage.removeItem('auditor-token')
          localStorage.removeItem('auditor-user')
          if (this.$route.path !== '/auditoria/login') this.$router.push('/auditoria/login')
        }
      } catch (e) {
        localStorage.removeItem('auditor-token')
        localStorage.removeItem('auditor-user')
        if (this.$route.path !== '/auditoria/login') this.$router.push('/auditoria/login')
      }
    },
    async logout() {
      try {
        // Não existe endpoint de logout auditoria (somente leitura).
        // Mantemos simétrico removendo token local.
        await Promise.resolve()
      } catch (e) {
        // noop
      } finally {
        localStorage.removeItem('auditor-token')
        localStorage.removeItem('auditor-user')
        delete axios.defaults.headers.common['Authorization']
        if (this.$route.path !== '/auditoria/login') this.$router.push('/auditoria/login')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.auditoria-layout {
  display: flex;
  min-height: 100vh;
  background: #f8f9fa;
}

.auditoria-sidebar {
  width: 280px;
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  color: white;
  transition: width 0.3s ease;
  position: fixed;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 1000;
  overflow-y: auto;

  &.collapsed {
    width: 70px;
  }
}

.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo {
    display: flex;
    align-items: center;
    img {
      height: 40px;
      width: auto;
    }
    i {
      font-size: 22px;
    }
  }

  .sidebar-toggle {
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: white;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }
  }
}

.sidebar-nav {
  padding: 20px 0;

  .nav-menu {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .nav-item {
    margin-bottom: 5px;
  }

  .nav-link {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    color: rgba(255, 255, 255, 0.85);
    text-decoration: none;
    transition: all 0.3s ease;
    position: relative;

    i {
      width: 20px;
      margin-right: 12px;
      font-size: 16px;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      color: white;
    }

    &.active {
      background: rgba(255, 255, 255, 0.2);
      color: white;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background: white;
      }
    }
  }
}

.auditoria-main {
  flex: 1;
  margin-left: 280px;
  transition: margin-left 0.3s ease;

  &.sidebar-collapsed {
    margin-left: 70px;
  }
}

.auditoria-header {
  background: white;
  padding: 18px 26px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);

  .page-title {
    font-size: 22px;
    font-weight: 700;
    color: #2c3e50;
    margin: 0;
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 12px;

    .user-avatar {
      width: 40px;
      height: 40px;
      background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 16px;
    }

    .user-details {
      display: flex;
      flex-direction: column;
      .user-name {
        font-weight: 700;
        color: #2c3e50;
        font-size: 14px;
      }
      .user-role {
        font-size: 12px;
        color: #6c757d;
      }
    }
  }

  .btn-logout {
    background: #dc3545;
    color: white;
    border: none;
    padding: 8px 14px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;

    &:hover {
      background: #c82333;
    }
  }
}

.auditoria-content {
  padding: 26px;
  min-height: calc(100vh - 80px);
}

@media (max-width: 768px) {
  .auditoria-main {
    margin-left: 0;
  }
  .auditoria-header {
    .user-details {
      display: none;
    }
    .btn-logout span {
      display: none;
    }
  }
}
</style>

